import { render, staticRenderFns } from "./pull-extend-package.vue?vue&type=template&id=6f3c49be&scoped=true"
import script from "./pull-extend-package.vue?vue&type=script&lang=js"
export * from "./pull-extend-package.vue?vue&type=script&lang=js"
import style0 from "./pull-extend-package.vue?vue&type=style&index=0&id=6f3c49be&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c49be",
  null
  
)

export default component.exports